import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import React, { useState, useEffect, useContext } from "react";
import { APIContext } from '../Contexts/APIContext';

interface PhotoPreviewProps {
    src?: string;
    smallWidth?: number;
    largeWidth?: number;
}

export function PhotoPreview({
    src,
    smallWidth = 250,
    largeWidth = 500,
}: PhotoPreviewProps) {
    const [hasError, setHasError] = useState(false);
    const { loading } = useContext(APIContext);

    useEffect(() => {
        if (src) {
            setHasError(false);
        }
    }, [src]);

    if (loading) {
        return (
            <Box
                sx={{
                    width: `${smallWidth}px`,
                    px: 2,
                    py: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "#f5f5f5",
                    gap: 1,
                }}
            >
                <LinearProgress sx={{ width: '100%' }} />
            </Box>
        );
    }
    if (!src) {
        return (
            <Box
                sx={{
                    width: `${smallWidth}px`,
                    px: 2,
                    py: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "#f5f5f5",
                }}
            >
                <Typography color="textSecondary" variant="body2">
                    No photo available
                </Typography>
            </Box>
        );
    }

    if (hasError) {
        return (
            <Box
                sx={{
                    width: `${smallWidth}px`,
                    px: 2,
                    py: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    backgroundColor: "#f5f5f5",
                }}
            >
                <Typography color="textSecondary" variant="body2">
                    No photo available
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                position: "relative",
                display: "inline-block",
                "&:hover .hover-preview": {
                    display: "block",
                },
            }}
        >
            <img
                src={src}
                alt="Site photo"
                onError={(e: React.SyntheticEvent) => {
                    setHasError(true);
                    console.log(e);
                }}
                style={{
                    width: `${smallWidth}px`,
                    height: "auto",
                    borderRadius: "5px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                }}
            />
            <Box
                component="div"
                className="hover-preview"
                sx={{
                    display: "none",
                    position: "absolute",
                    top: 0,
                    left: `${smallWidth + 10}px`,
                    zIndex: 10,
                    background: "#fff",
                    borderRadius: "5px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                }}
            >
                <img
                    src={src}
                    alt="Site photo enlarged"
                    onError={() => setHasError(true)}
                    style={{
                        width: `${largeWidth}px`,
                        height: "auto",
                        borderRadius: "5px",
                    }}
                />
            </Box>
        </Box>
    );
}